function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "52 42 88 66"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#4285f4",
  d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34a853",
  d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fbbc04",
  d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M72 74V48l24 18 24-18v26L96 92"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c5221f",
  d: "M52 51v8l20 15V48l-5.6-4.2C60.46 39.35 52 43.58 52 51"
})));